import type { SiteContent } from "../schema.ts";
import { media } from "../media.ts";

const p = media.projects;

export const ar = {
  locale: "ar",
  dir: "rtl",
  localeSwitch: {
    href: "/en",
    label: "EN",
    aria: "التبديل الى الانجليزية",
  },
  name: "Xattir",
  slogan: "منتجات تخرج للسوق. تجارب تبقى.",
  title: "Xattir. تصميم وهندسة للفرق الطموحة",
  description:
    "تصمم Xattir وتبني منتجات ويب وموبايل عالية الاثر لفرق التعليم والرعاية والتجارة والمؤسسات.",
  origin: media.origin,
  ogImage: media.ogImage,
  ogImageAlt: "Xattir. تصميم وهندسة.",
  keywords: [
    "Xattir",
    "تصميم المنتجات",
    "هندسة المنتجات",
    "تطبيقات ويب",
    "تطبيقات موبايل",
    "SaaS",
  ],
  nav: [
    { label: "الاعمال", section: "work" },
    { label: "الخدمات", section: "services" },
    { label: "المنتجات", section: "products" },
    { label: "قصتنا", section: "story" },
  ],
  jumpMenu: [
    { label: "الرئيسية", section: "hero" },
    { label: "اعمالنا", section: "work" },
    { label: "خدماتنا", section: "services" },
    { label: "منتجاتنا", section: "products" },
    { label: "قصتنا", section: "story" },
    { label: "تواصل معنا", section: "contact" },
  ],
  cta: { label: "ابدأ مشروعا", section: "contact" },
  hero: {
    lines: ["التصميم والهندسة", "لنتائج حقيقية."],
    subhead:
      "نصمم ونهندس ونطلق منتجات رقمية تضعها الفرق الطموحة امام مستخدمين حقيقيين.",
  },
  work: {
    lines: ["اعمال مختارة.", "منتجات حقيقية.", "تسلم بسرعة."],
    label: "احدث\nالمشاريع",
    more: "والمزيد.",
  },
  projects: [
    {
      id: "case-1",
      title: "MKIT",
      client: "MKIT",
      description:
        "صممنا وبنينا MKIT، تجربة تجارة لمجموعات التخرج حيث تخصص المدارس كل تفصيل، من التطريز الى الالقاب، ويطلب الخريجون في مسار واحد سلس.",
      tags: [
        "تصميم المنتج",
        "التجارة الالكترونية",
        "هندسة المنصات",
        "تجربة العلامة",
      ],
      outcome: "باني مجموعات جاهز للمدارس مع دفع آمن وحضور علامة لا ينسى.",
      url: p["case-1"].url,
      cover: p["case-1"].cover,
      coverMobile: p["case-1"].coverMobile,
      coverAlt: "صورة استوديو تجريدية لتفاصيل ملابس مخصصة.",
      slide: p["case-1"].slide,
      caseStudyId: "mkit",
    },
    {
      id: "case-2",
      title: "Kenaz Advisors",
      client: "Kenaz",
      description:
        "بنينا Kenaz كمنصة تعلم واستشارات ACCA. دورات مباشرة ومسجلة، ملفات المستشارين، التسجيل، ومحتوى يساعد المهنيين الماليين على اجتياز الاختبارات والنمو.",
      tags: [
        "منصة تعليم",
        "تصميم التجربة والواجهة",
        "تجارة الدورات",
        "انظمة المحتوى",
      ],
      outcome: "مركز تعلم ACCA موثوق بدورات ومستشارين وتفاعل عبر البودكاست.",
      url: p["case-2"].url,
      cover: p["case-2"].cover,
      coverMobile: p["case-2"].coverMobile,
      coverAlt: "طبيعة صامتة دافئة لدفاتر ومصباح مكتب.",
      slide: p["case-2"].slide,
      caseStudyId: "kenaz",
    },
    {
      id: "case-3",
      title: "CareLend",
      client: "CareLend",
      description:
        "سلمنا منصة CareLend لمسارات التمريض الدولية، لربط الممرضين المؤهلين بالمستشفيات الالمانية عبر توظيف عادل، تدريب لغوي، ورحلات تعيين كاملة.",
      tags: [
        "منصة رعاية صحية",
        "تجربة متعددة الاسواق",
        "مسارات التوظيف",
        "تسليم كامل",
      ],
      outcome: "تجربة تعيين اخلاقية تغطي الاهلية والتدريب والتاشيرة والاندماج.",
      url: p["case-3"].url,
      cover: p["case-3"].cover,
      coverMobile: p["case-3"].coverMobile,
      coverAlt: "ممر معاصر هادئ من الحجر والضوء.",
      slide: p["case-3"].slide,
      caseStudyId: "carelend",
    },
    {
      id: "case-4",
      title: "والمزيد.",
      client: "Xattir",
      description:
        "نظرة اوسع على منتجات نصممها ونطلقها: التعليم، الاسكان، هندسة الرعاية، والتدريب المهني.",
      tags: ["هندسة المنصات", "تصميم المنتج", "تسليم متعدد الاسواق"],
      outcome:
        "شاشات مختارة من Torque Academy وCL-Bildung وSFNDY وQimmmah والمزيد.",
      url: p["case-4"].url,
      cover: p["case-4"].cover,
      coverMobile: p["case-4"].coverMobile,
      coverAlt: "كولاج تجريدي لالواح زجاج بلوري.",
      plane: p["case-4"].plane,
      slide: p["case-4"].slide,
      marquee: true,
    },
  ],
  projectsMore: media.projectsMore,
  caseStudies: [
    {
      id: "mkit",
      title: "MKIT",
      client: "MKIT",
      eyebrow: "منصة تجارة",
      summary:
        "باني مجموعات تخرج تخصص فيه المدارس كل تفصيل ويطلب الخريجون في مسار واحد.",
      problem:
        "المدارس احتاجت تجارة مجموعات بعلامة دون جداول، دفع معطل، او فوضى انتاج لمرة واحدة.",
      outcome:
        "منصة مجموعات جاهزة للمدارس مع تحكم بالتطريز ودفع آمن وحضور علامة يتذكره الخريجون.",
      stack: ["Next.js", "تجارة", "مكون تخصيص", "مدفوعات"],
      preview: media.caseStudies.mkit,
      previewAlt: "معاينة واجهة منتج MKIT.",
      url: "https://new.mkiteg.com/",
    },
    {
      id: "kenaz",
      title: "Kenaz Advisors",
      client: "Kenaz",
      eyebrow: "تعليم واستشارات",
      summary:
        "مركز تعلم ACCA بدورات مباشرة ومستشارين وتسجيل ومحتوى يحول الطموح الى تقدم.",
      problem:
        "المهنيون الماليون احتاجوا مكانا موثوقا واحدا للدورات والمستشارين ومحتوى الاختبارات.",
      outcome:
        "منصة تعلم واستشارات تجمع تجارة الدورات مع تفاعل عبر البودكاست.",
      stack: ["تصميم المنتج", "تجارة الدورات", "CMS", "مسارات التسجيل"],
      preview: media.caseStudies.kenaz,
      previewAlt: "معاينة منصة Kenaz Advisors.",
      url: "https://kenazadvisors.com/",
    },
    {
      id: "carelend",
      title: "CareLend",
      client: "CareLend",
      eyebrow: "مسارات رعاية",
      summary:
        "تعيين تمريض اخلاقي من الاهلية عبر التدريب اللغوي والتاشيرة واندماج المستشفى.",
      problem:
        "توظيف التمريض عبر الحدود كان مجزءا بين الوكالات والاوراق ومسارات مرشحين غامضة.",
      outcome:
        "منصة متعددة الاسواق تبقي الممرضين والمستشفيات متوافقين من الخطوة الاولى حتى التعيين.",
      stack: ["تسليم كامل", "تجربة متعددة اللغات", "انظمة سير العمل", "CRM"],
      preview: media.caseStudies.carelend,
      previewAlt: "معاينة منصة CareLend.",
      url: "https://carelend.xattir.com/en",
    },
    {
      id: "torque",
      title: "Torque Academy",
      client: "Torque Academy",
      eyebrow: "منتج تعلم",
      summary:
        "سطح تعلم مهني مبني للوضوح والتقدم والتسليم الحقيقي تحت الحمل.",
      problem:
        "فرق التدريب احتاجت منتجا فاخرا دون ابطاء تشغيل الدورات او زخم المتعلمين.",
      outcome:
        "تجربة اكاديمية مركزة بواجهة واضحة ومسارات يمكن انهاءها فعلا.",
      stack: ["تصميم المنتج", "مسارات تعلم", "تطبيق ويب"],
      preview: media.caseStudies.torque,
      previewAlt: "معاينة واجهة Torque Academy.",
      url: "#",
    },
    {
      id: "cl-bildung",
      title: "CL-Bildung",
      client: "CL-Bildung",
      eyebrow: "انظمة تعليم",
      summary:
        "هندسة منتج تعليمي لبرامج منظمة وتسليم متعدد الاسواق.",
      problem:
        "مشغلو البرامج احتاجوا نظاما رقميا يطابق صرامة التدريب المهني الحضوري.",
      outcome:
        "سطح تعليمي نظيف يبقي البرامج والمتعلمين والتشغيل على ايقاع واحد.",
      stack: ["هندسة المنصات", "انظمة التصميم", "تكاملات"],
      preview: media.caseStudies["cl-bildung"],
      previewAlt: "معاينة منتج CL-Bildung.",
      url: "#",
    },
    {
      id: "sfndy",
      title: "SFNDY",
      client: "SFNDY",
      eyebrow: "اسكان وتشغيل",
      summary:
        "حرفة منتج لفرق الاسكان والتشغيل التي تحتاج سرعة دون فقدان الثقة.",
      problem:
        "المشغلون احتاجوا برمجيات تبدو بقدر موثوقية الخدمة التي يبيعونها.",
      outcome:
        "تجربة منتج متماسكة مضبوطة للتشغيل اليومي ووضوح واجهة العميل.",
      stack: ["تصميم المنتج", "تطبيق ويب", "مسارات تشغيل"],
      preview: media.caseStudies.sfndy,
      previewAlt: "معاينة منتج SFNDY.",
      url: "#",
    },
    {
      id: "qimmmah",
      title: "Qimmmah",
      client: "Qimmmah",
      eyebrow: "تقنية وعلامة",
      summary:
        "منتج رقمي حاد يجمع العمق التقني مع علامة يفخر الفريق بعرضها.",
      problem:
        "قصة المنتج والهندسة احتاجتا ان تصلا كتجربة واحدة متماسكة.",
      outcome:
        "سطح مصقول يحمل القدرة والهوية دون ضوضاء.",
      stack: ["تجربة وواجهة", "واجهة امامية", "انظمة العلامة"],
      preview: media.caseStudies.qimmmah,
      previewAlt: "معاينة منتج Qimmmah.",
      url: "#",
    },
  ],
  services: [
    {
      id: "digital",
      name: "التجارب الرقمية",
      description:
        "مواقع وصفحات هبوط ومسارات تجارة مبنية للتحويل. واضحة وسريعة وعلى هوية العلامة.",
      subservices: [
        "المواقع",
        "صفحات الهبوط",
        "تجارب تفاعلية",
        "التجارة الالكترونية",
        "انظمة المحتوى",
      ],
      highlights: [
        "مواقع وتسويق وصفحات هبوط مهندسة للتحويل لا للزينة",
        "مسارات تجارة واضحة من التصفح الى الدفع",
        "حركة وتفاعل يوجهان الانتباه دون ابطاء الصفحة",
        "نماذج محتوى جاهزة للمحررين ليطلقوا فعليا",
        "ميزانيات اداء وامكانية وصول مدمجة في الحرفة",
      ],
      image: media.services.digital,
      imageAlt: "سطح رقمي داكن بملمس زجاجي.",
    },
    {
      id: "product",
      name: "تطوير المنتجات",
      description:
        "منتجات SaaS وتطبيقات ويب ومنصات مهندسة لتخرج بسرعة وتبقى مستقرة تحت الحمل الحقيقي.",
      subservices: [
        "منتجات SaaS",
        "تطبيقات الويب",
        "لوحات التحكم",
        "المنصات",
        "برمجيات مخصصة",
      ],
      highlights: [
        "SaaS وتطبيقات ويب بهندسة تصمد امام مستخدمين حقيقيين",
        "لوحات تحكم تجعل البيانات الكثيفة واضحة",
        "اسس منصات يمكن توسيعها دون اعادة كتابة",
        "برمجيات مخصصة مضبوطة على النتائج لا على مسرح الميزات",
        "دورات اطلاق بمراجعة وضمان جودة وانضباط اصدار",
      ],
      image: media.services.product,
      imageAlt: "طبقات اكريليك داكنة توحي بهندسة المنتج.",
    },
    {
      id: "mobile",
      name: "تطبيقات الموبايل",
      description:
        "تطبيقات iOS وAndroid ومتعددة المنصات بشعور اصلي واداء جيد وقابلية صيانة.",
      subservices: [
        "تطبيقات iOS",
        "تطبيقات Android",
        "تطبيقات متعددة المنصات",
        "نشر المتاجر",
        "تجربة الموبايل",
      ],
      highlights: [
        "تجارب iOS وAndroid بشعور اصلي",
        "بناء متعدد المنصات عندما تهم السرعة والتماثل",
        "تجربة موبايل مضبوطة لليد والحواف غير المتصلة والاجهزة الحقيقية",
        "تقديم للمتاجر واصدارات ونظافة اصدار",
        "قواعد كود قابلة للصيانة ليستمر فريقك في الاطلاق",
      ],
      image: media.services.mobile,
      imageAlt: "حافة هاتف اسود مطفي بضوء خفيف.",
    },
    {
      id: "design",
      name: "تصميم المنتج",
      description:
        "تجربة وواجهة وانظمة تصميم تجعل المنتجات المعقدة واضحة، من الاستراتيجية الى الواجهة.",
      subservices: [
        "بحث التجربة",
        "تصميم الواجهة",
        "انظمة التصميم",
        "استراتيجية المنتج",
        "النماذج الاولية",
      ],
      highlights: [
        "بحث يكشف الوظائف الحقيقية المطلوبة",
        "واجهات بهرمية وانضباط وجاذبية علامة",
        "انظمة تصميم تتوسع دون انحراف بصري",
        "ورش استراتيجية تغلق المشكلة قبل البكسل",
        "نماذج اولية تقلل مخاطر القرارات المكلفة مبكرا",
      ],
      image: media.services.design,
      imageAlt: "مكتب اسود مع شبكة هندسية وبطاقات ورق.",
    },
    {
      id: "ai",
      name: "الذكاء الاصطناعي والاتمتة",
      description:
        "منتجات ذكاء اصطناعي ووكلاء ومسارات ذكية تزيل العمل المتكرر وتفتح قدرات جديدة.",
      subservices: [
        "منتجات الذكاء الاصطناعي",
        "الوكلاء",
        "مسارات ذكية",
        "اتمتة الاعمال",
        "دمج نماذج اللغة",
      ],
      highlights: [
        "ميزات ذكاء مدمجة في مسارات المنتج لا كعروض منفصلة",
        "وكلاء ومسارات تقطع العمل المتكرر بعائد قابل للقياس",
        "دمج نماذج لغة بحواجز وتقييم وتجاوز بشري",
        "اتمتة عبر الادوات التي تديرها فرقك بالفعل",
        "افتراضات مسؤولة: خصوصية وضبط تكلفة ومسارات بديلة",
      ],
      image: media.services.ai,
      imageAlt: "كوكبة داكنة من عقد سير عمل متصلة.",
    },
    {
      id: "systems",
      name: "الانظمة والتكاملات",
      description:
        "واجهات وربط تصل المدفوعات وانظمة CRM وERP والادوات التي تديرها فرقك بالفعل.",
      subservices: [
        "واجهات البرمجة",
        "تكاملات خارجية",
        "المدفوعات",
        "CRM و ERP",
        "ادوات داخلية",
      ],
      highlights: [
        "واجهات برمجة مصممة للشركاء ولسطح منتجك",
        "ربط مدفوعات وCRM وERP يبقى موثوقا",
        "لصق طرف ثالث دون سكربتات هشة لمرة واحدة",
        "ادوات داخلية تستبدل حلول الجداول",
        "مراقبة حتى تفشل التكاملات بصوت عال وتتعافى بنظافة",
      ],
      image: media.services.systems,
      imageAlt: "وصلات معدنية مشغولة على فحم.",
    },
    {
      id: "scale",
      name: "النطاق والدعم",
      description:
        "سحابة وDevOps وتطوير مستمر حتى يبقى ما تطلقه اسرع واكثر اعتمادا.",
      subservices: [
        "البنية السحابية",
        "DevOps",
        "تحسين الاداء",
        "التحديث",
        "تطوير مستمر",
      ],
      highlights: [
        "بنية سحابية بحجم النمو لا بالتخمين",
        "مسارات DevOps تجعل الاصدارات مملة بافضل معنى",
        "عمل اداء يشعر به المستخدم من اول رسم",
        "مسارات تحديث بعيدا عن الارث دون اعادة كتابة شاملة",
        "عقود تطوير مستمر تحمي الزخم",
      ],
      image: media.services.scale,
      imageAlt: "ممر قاعة خوادم هادئ في شبه ظلام.",
    },
  ],
  pages: {
    services: {
      title: "الخدمات",
      description:
        "تصميم وهندسة وذكاء اصطناعي وانظمة من Xattir. فريق حرفة واحد عبر التجارب والمنتجات والنطاق.",
      headline: "ما نطلقه.",
      subhead:
        "سبعة خطوط خدمة. معيار واحد: منتجات وتجارب تضعها الفرق الطموحة امام مستخدمين حقيقيين.",
      band: {
        headline: "جاهز للبناء؟",
        body: "اخبرنا بالنتيجة. نحدد مزيج الخدمات والبنية وموعد الاطلاق الاول.",
        cta: "ابدأ مشروعا",
      },
    },
    work: {
      title: "الاعمال",
      description:
        "دراسات حالة مختارة من Xattir عبر التجارة والتعليم والرعاية ومنصات المنتجات.",
      headline: "اعمال مختارة.",
      subhead:
        "دراسات حالة من منتجات صممناها وهندسناها. افتح بطاقة للمشكلة والنتيجة والبنية.",
      band: {
        headline: "لديك منتج في بالك؟",
        body: "نشارك الفرق التي تحتاج الحرفة والتسليم في غرفة واحدة. لنتحدث عن النطاق.",
        cta: "ابدأ مشروعا",
      },
    },
  },
  products: [
    {
      id: "productA",
      name: "Atlas",
      tagline: "مبنية للتعلم",
      description:
        "منصة تعلم تحول الدورات والمجموعات والتقييمات الى مسارات واضحة، فيدرس المدربون بتركيز ويعرف المتعلمون الخطوة التالية دائما.",
      sideDescription:
        "دورات ومجموعات وتقييمات في منصة تعلم واحدة. مسارات واضحة للمدربين والمتعلمين.",
      modules: [
        "مسارات الدورات",
        "جلسات مباشرة ومجموعات",
        "التقييمات والشهادات",
        "رؤى التقدم",
      ],
      integrations: [
        "SSO والهوية",
        "بوابات الدفع",
        "منصات الفيديو",
        "التحليلات",
      ],
      integrationsLabel: "ملاحظات التكامل",
      modulesLabel: "الوحدات الاساسية",
      video: media.products.productA.video,
      logos: media.products.productA.logos,
    },
    {
      id: "productB",
      name: "Orbit",
      tagline: "علاقات على ايقاع",
      description:
        "نظام CRM يبقي خط الانابيب والمحادثات والتسليم في مكان واحد، فتعرف فرق المبيعات والنجاح الخطوة التالية دائما.",
      sideDescription:
        "خط انابيب ومحادثات وتسليم في CRM واحد، فتعرف المبيعات والنجاح الخطوة التالية دائما.",
      modules: [
        "الخط والصفقات",
        "جهات الاتصال والحسابات",
        "الجدول الزمني",
        "الرؤى والتنبيهات",
      ],
      integrations: [
        "البريد والتقويم",
        "بوابات الدفع",
        "انظمة خارجية",
        "التحليلات",
      ],
      integrationsLabel: "ملاحظات التكامل",
      modulesLabel: "الوحدات الاساسية",
      video: media.products.productB.video,
      logos: media.products.productB.logos,
    },
  ],
  about: {
    headline: ["بلا حدود.", "مبنية لتدوم."],
    body: "توجد Xattir لتطلق منتجات تصنع معاملات حقيقية وتجارب يتذكرها الناس. نوازن الحرفة والتفكير النظمي والتسليم حتى تعمل المنتجات الرقمية على نطاق واسع، وتبقى في قلوب المستخدمين وعقولهم.",
    reach: "نبني للفرق الطموحة اينما كانت.",
    facts: [
      { value: 80, suffix: "+", label: "مشاريع" },
      { value: null, suffix: "", label: "اسواق", symbol: "∞" },
      { value: 5, suffix: "+", label: "دول" },
      { value: 10, suffix: "+", label: "خدمات" },
    ],
  },
  clients: [
    { name: "MKIT" },
    { name: "Kenaz Advisors" },
    { name: "CareLend" },
    { name: "Torque Academy" },
    { name: "CL-Bildung" },
    { name: "SFNDY" },
    { name: "Qimmmah" },
  ],
  markets: [
    { id: "eg", name: "مصر", ...media.markets.eg },
    { id: "kw", name: "الكويت", ...media.markets.kw },
    { id: "ae", name: "UAE", ...media.markets.ae },
    { id: "sa", name: "KSA", ...media.markets.sa },
    { id: "us", name: "USA", ...media.markets.us },
    { id: "de", name: "المانيا", ...media.markets.de },
    { id: "dk", name: "الدنمارك", ...media.markets.dk },
  ],
  contact: {
    successTitle: "شكرا لتواصلك!",
    successMessage: "سيعود فريقنا اليك في اقرب وقت.",
    headline: "لنبن ما يلي.",
    submit: "ارسال الرسالة",
    cover: media.contactCover,
    currencies: ["EGP", "USD"],
    prompts: [
      "ماذا تبني؟",
      "ما المشكلة التي تحاول حلها؟",
      "كيف يبدو النجاح؟",
      "حدثنا عن فكرتك.",
      "ما اهدافك؟",
    ],
    form: {
      nameLabel: "الاسم",
      namePlaceholder: "الاسم الكامل",
      businessLabel: "اسم العمل",
      businessOptional: "(اختياري)",
      businessPlaceholder: "الشركة او الاستوديو",
      phoneLabel: "رقم الهاتف",
      phonePlaceholder: "1XX XXX XXXX",
      emailLabel: "البريد",
      emailOptional: "(اختياري)",
      emailPlaceholder: "بريد العمل",
      budgetLabel: "نطاق الاستثمار المتوقع",
      budgetPlaceholder: "النطاق المفضل",
      currencyPlaceholder: "العملة",
      detailsLabel: "صف مشروعك واهدافك",
      detailsPlaceholder: "حدثنا اكثر.",
    },
    errors: {
      nameRequired: "الاسم مطلوب",
      phoneRequired: "الهاتف مطلوب",
      phoneCountry: "اختر رمز الدولة",
      phoneInvalid: "ادخل رقما صالحا للدولة المختارة",
      emailInvalid: "ادخل بريدا صالحا",
      currencyRequired: "العملة مطلوبة",
      detailsRequired: "حدثنا قليلا عن المشروع",
      submitFailed: "حدث خطأ. حاول مرة اخرى.",
    },
    whatsappMessage: "مرحبا Xattir — اريد التحدث عن مشروع.",
  },
  offices: media.offices,
  sideWork: "",
  sideContact: "حدثنا عما تبنيه. نساعدك على اطلاقه بوضوح وحرفة.",
  sideContactFocus: ["هندسة المنصات", "تصميم المنتج", "تسليم متعدد الاسواق"],
  labels: {
    contactUs: "تواصل معنا",
    bookDemo: "احجز عرضا",
    subservices: "خدمات فرعية",
    focus: "التركيز",
    trustedBy: "موثوق لدى فرق في",
    viewAllServices: "عرض كل الخدمات",
    viewCaseStudy: "عرض دراسة الحالة",
    viewAllProjects: "عرض كل المشاريع",
    close: "اغلاق",
    visitSite: "زيارة الموقع",
    problem: "المشكلة",
    outcome: "النتيجة",
    stack: "البنية",
    backHome: "العودة للرئيسية",
  },
  aria: {
    home: "Xattir. الرئيسية",
    jumpMenu: "اقسام الصفحة",
    marketsMap: "الاسواق التي نعمل عبرها",
    storyVisual: "منظر ليلي للارض كحقل من الاضواء",
    landscapeMessage: "لتجربة افضل، ادر الجهاز الى الوضع العمودي.",
    landscapeDismiss: "اخفاء",
    decorative: "زخرفي",
    infinity: "ما لا نهاية",
    countryCodes: "رموز اتصال الدول",
  },
} as const satisfies SiteContent;
